import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { EventEmitter, Injectable, Output } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { catchError, delay, Observable, throwError } from 'rxjs'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Player } from '../../../core/models/player.model'
import { environment } from '../../../../environments/environment'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { firstValueFrom } from 'rxjs'
import { Match } from 'src/app/core/models/match.model'

@Injectable({
  providedIn: 'root'
})
export class ScoresService {

  constructor(private _snackBar: MatSnackBar, 
    private sanitizer: DomSanitizer,
    private fb:FormBuilder, 
    private http: HttpClient) { }

  readonly baseURL = environment.DOMAIN_URL+'/api/scores/'
  list: any[] = []
  interactiveMode: boolean = true
  opened: boolean=false

  @Output() filtersSubmittedEvent = new EventEmitter<null>()

  FiltersSubmitted(){
    this.filtersSubmittedEvent.emit()
  }
  
  scoreForm = this.fb.group({
    _id : [''],
    player_id: this.fb.control<Player | null>(null, [Validators.required]),
    match_id: this.fb.control<Match | null>(null, [Validators.required]),
    starter: [''],
    fotmob: this.fb.control<number | null>(null, [Validators.required]),
    atscore: this.fb.control<number | null>(null),
  })

  filters = this.fb.group({
    season: ['2024/2025'],
    match: [''],
    rival: [''],
    player: [''],
    starter: [''],
    stadium: [''],
    appereances: this.fb.control<number | null>(null),
    fromDate: this.fb.control<Date | null>(null),
    toDate: this.fb.control<Date | null>(null),
  })

  importForm = this.fb.group({
    textArea: ['']
  })

  fetchScoreList(){
    return this.http.get(this.baseURL)
    .pipe(catchError(this.errorHandler))
  }

  fetchFilteredScoreList(): Observable<{scores:any, stats:any}>{
    return this.http.post<{scores: any, stats: any}>(this.baseURL+'filters',this.filters.value)
    .pipe(catchError(this.errorHandler))
  }

  postScore(){
    return this.http.post(this.baseURL, this.scoreForm.value)
    .pipe(catchError(this.errorHandler))
  }

  putScore(){
    return this.http.put(this.baseURL+this.scoreForm.get('_id')?.value, this.scoreForm.getRawValue())
    .pipe(catchError(this.errorHandler))
  }

  deleteScore(_id:string){
    return this.http.delete(this.baseURL+_id)
    .pipe(catchError(this.errorHandler))
  }

  async fetchFoto(_id:string) {
    try{
      const response = await firstValueFrom(this.http.get<{ foto: string }>(this.baseURL+'foto/'+_id)
      //.pipe(delay(500),catchError(this.errorHandler)))
      .pipe(catchError(this.errorHandler)))
      return this.getSanitizedImageUrl(response.foto) as SafeUrl
    } catch (error) {
      return undefined
    }
  }

  getSanitizedImageUrl(base64: string): SafeUrl {
    const url = `data:image/jpeg;base64,${base64}`
    return this.sanitizer.bypassSecurityTrustResourceUrl(url)
  }
  
  importScores(){
    let payload = {
      "textArea": this.importForm.value.textArea,
      "match_id": this.scoreForm.value.match_id
    }
    return this.http.post(this.baseURL+'import', payload)
    .pipe(catchError(this.errorHandler))
  }

  private errorHandler(error: HttpErrorResponse) {
    if (error.status === 0) console.error('An error occurred:', error.error)
    else console.error(`Backend returned code ${error.status}, body was: `, error.error)
    return throwError(() => new Error('Something bad happened; please try again later.'))
  }

  openSnackBar(message: string) {
    this._snackBar.open(message)
  }
}